/* -----------------------------
 *  mobile footer nav
 -----------------------------*/

window.footerMenuOpen = function footerMenuOpen() {
    $('.footerWrap .menuWrap ul').each(function () {
        if ($(this).is(':visible')) {
            $(this).siblings('h3').addClass('open');
        }
    });
}

$(document).ready(function () {
    'use strict';

    footerMenuOpen();

    $('.footerWrap .menuWrap h3').on('click', function () {
        if (windowWidth <= window.breakpoints.mobile) {
            $(this).toggleClass('open');
            $(this).parents('.column').find('ul').stop(true, true).slideFadeToggle();
        }
    });
});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    footerMenuOpen();

    if (windowWidth > window.breakpoints.mobile) {
        $('.footerWrap .menuWrap ul').show();
        $('.footerWrap .menuWrap h3').removeClass('open');
        $('.flyoutWrap').attr('style', '');
    }
}));